import { DateFilter, Sorter } from "services/CommonDT";
import { CommonDT, PageParams, ResultType } from "../../CommonDT";
import { _delete, _get, _post, _put, _req } from "../../request";
import { VideoAlbumDataType } from "./video-album-api";
import { VideoTagDataType } from "./video-tag-api";
import { VideoTypeDataType } from "./video-type-api";

// export type VideoDataType = CommonDT & {
//   videoName: string;
//   videoDuration: number;
//   videoUrl: string;
//   coverUrl: string;
//   likeCount: number;
//   hoardCount: number;
//   commentCount: number;
//   hotIndex: number;
//   fkVideoMediaUuid: string;
//   fkCoverMediaUuid: string;
//   fkVideoTypeUuid: string;
//   fkVideoAlbumUuid: string;
// };

export type VideoDataType = {
  postUuid: string;
  postTitle: string;
  postCoverUrl: string;
  postSourceType: string;
  termUuid: string;
};

export type VideoBatchDataType = {
  videos: VideoDataType[];
};

export type VideoBzType = {
  // userId: string;
  postId: string;
  // termId: string;
  videoListId: string;
  // upperCommentId?: string;
};

export type VideoPageDataType = {
  pageParams: PageParams;
  filter?: VideoDataType;
  dateFilter?: DateFilter;
  sorter?: Sorter;
};

export type SearchVideoDT = {
  keyword: string;
  typeId?: string;
  tagId?: string;
  sortType?: string;
};

export type VideoWithTag = VideoDataType & {
  tagList: VideoTagDataType[];
  videoType: VideoTypeDataType;
  videoAlbum: VideoAlbumDataType;
};

const get = async (id: string): Promise<ResultType> => {
  return await _get("/cnt/video/", id);
};

const list = async (data?: VideoDataType): Promise<ResultType> => {
  return await _post("/cnt/video/list", data);
};

const listByTag = async (tagId: string): Promise<ResultType> => {
  return await _get("/cnt/video/listByTag/", tagId);
};

const listByAlbum = async (albumId: string): Promise<ResultType> => {
  return await _get("/cnt/video/listByAlbum/", albumId);
};

const page = async (data?: VideoPageDataType): Promise<ResultType> => {
  return await _post("/cnt/video/page", data);
};

const pageByType = async (pageParams: PageParams, fkVideoTypeUuid: string, isRootType: {}): Promise<ResultType> => {
  return await _req("/cnt/video/page", "post", isRootType, {
    pageParams,
    filter: { fkVideoTypeUuid },
  });
};

const pageByTypeSort = async (
  pageParams: PageParams,
  fkVideoTypeUuid: string,
  sortType: number
): Promise<ResultType> => {
  return await _req(
    "/cnt/video/pageByTypeSort",
    "post",
    {},
    {
      pageParams,
      fkVideoTypeUuid,
      sortType,
    }
  );
};

const pageByTagSort = async (pageParams: PageParams, fkVideoTagUuid: string, sortType: number): Promise<ResultType> => {
  return await _req(
    "/cnt/video/pageByTagSort",
    "post",
    {},
    {
      pageParams,
      fkVideoTagUuid,
      sortType,
    }
  );
};

const batchSave = async (data: VideoBatchDataType): Promise<ResultType> => {
  return await _post("/cnt/video/batchSave", data);
};

const batchUpdate = async (data: VideoBatchDataType): Promise<ResultType> => {
  return await _put("/cnt/video/batchUpdate", data);
};

const alterStatus = async (videoId: string, status: number): Promise<ResultType> => {
  return await _req("/cnt/video/alterStatus", "PUT", { videoId, status });
};

// const doLike = async (data: VideoBzType): Promise<ResultType> => {
//   return await _put("/cnt/video/doLike", data);
// };

// const unLike = async (data: VideoBzType): Promise<ResultType> => {
//   return await _put("/cnt/video/unLike", data);
// };

const getRecordExists = async (data: VideoBzType): Promise<ResultType> => {
  return await _post("/usr/videoList/getRecordExists", data);
};

const add2List = async (data: VideoBzType): Promise<ResultType> => {
  return await _put("/usr/videoList/add2List", data);
};

const del4List = async (data: VideoBzType): Promise<ResultType> => {
  return await _put("/usr/videoList/del4List", data);
};

const batchRemove = async (ids: string[]): Promise<ResultType> => {
  return await _delete("/cnt/video/batchRemove", ids);
};

const search = async (data: SearchVideoDT): Promise<ResultType> => {
  return await _post("/cnt/search/video", data);
};

const searchVideo = async (videoId: string): Promise<ResultType> => {
  return await _get("/cnt/search/video/", videoId);
};

const videoRec = async (count: number): Promise<ResultType> => {
  return await _get("/cnt/search/videoRec/", count + "");
};

const VideoApi = {
  get,
  list,
  listByTag,
  listByAlbum,
  page,
  pageByType,
  pageByTypeSort,
  pageByTagSort,
  batchSave,
  batchUpdate,
  alterStatus,
  batchRemove,
  // doLike,
  // unLike,
  getRecordExists,
  add2List,
  del4List,
  search,
  searchVideo,
  videoRec,
};

export default VideoApi;
